<div class="form" *appSheetsAppContext>
  <div class="form-date">{{ sheetFolder?.createdAt | dateFormat:'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="folder"
      [style.color]="sheetFolder?.color"
    />
    {{ sheetFolder?.title }}
  </h2>

  @if (sheetFolder) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="sheetFolder"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="sheetFolder"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Parent Folder</div>
      <div class="form-details-row-input">{{ sheetFolder?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">
        Description
      </div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="sheetFolder?.description" />
    </div>
  </div>
</div>
